// extracted by extract-css-chunks-webpack-plugin
module.exports = {"api-dev-portal__button":"api-dev-portal__button","button--primary":"button--primary","button--reg":"button--reg"};